// "Google ile Devam Et" butonu (resmi renkli G logosu). onClick sağlanır.
export default function GoogleButton({ onClick, loading = false, label = "Google ile Devam Et", testid = "google-btn" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      data-testid={testid}
      className="w-full h-12 rounded-xl border border-slate-200 bg-white text-[#0F172A] font-medium flex items-center justify-center gap-3 hover:bg-slate-50 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
    >
      <svg className="h-5 w-5" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
        <path fill="#4CAF50" d="M24 44c5.5 0 10.4-2.1 14.1-5.5l-6.5-5.5C29.5 34.7 26.9 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.6 39.6 16.2 44 24 44z" />
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.2 5.5l6.5 5.5C41.9 36.9 44 31 44 24c0-1.3-.1-2.3-.4-3.5z" />
      </svg>
      {loading ? "Yönlendiriliyor..." : label}
    </button>
  );
}
